<template>
  <div class="snackbar">
    <transition name="snackfade">
      <div class="snack" :class="'has-text-' + snackbar.color" v-if="snackbar && ($store.state.isAdmin || snackbar.public)" v-html="html"></div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'snackbar',
  computed: {
    snackbar () {
      return this.$store.state.snackbar
    },
    html () {
      var html = ''
      if (this.snackbar.title !== '') {
        html += '<strong class="has-text-' + this.snackbar.color + '">' + this.snackbar.title + '</strong>'
      }
      html += this.snackbar.message
      return html
    }
  }
}
</script>

<style lang="scss" scoped>

.snackfade-enter-active, .snackfade-leave-active {
  transition: all .2s;
}
.snackfade-enter, .snackfade-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
.snackbar{
  position: fixed;
  top: 20px;
  left: 0px;
  z-index: 1042;
  width: 100%;
  height: 0;
  overflow: visible;
  opacity: 1;
  .snack{
    background-color: $black-bis;
    color: $white;
    // font-weight: 600;
    padding: 12px 24px;
    border-radius: 4px;
    box-shadow: 0px 4px 10px rgba(0,0,0,.6);
    width: 400px;
    display: block;
    margin: 0 auto;

    /deep/strong[class*=has-text-]{
      display: block;
    }
  }
}
</style>
